import React from "react";
import { Form } from "react-bootstrap";
import FormInput from "../../../../../Components/UI/FormInput";
import SideModal from "../../../../../Components/UI/SideModal/SideModal";

interface IEditCompany {
  show: boolean;
  onChangeValue: any;
  company: any;
  close: any;
  editCompanyClass?: any;
  companyInputButtonsClass: any;
  onCheck: any;
  onSubmit: any;
  onCancel: any;
}

const EditComapnyModal = ({
  show,
  onChangeValue,
  company,
  editCompanyClass,
  close,
  companyInputButtonsClass,
  onCheck,
  onSubmit,
  onCancel,
}: IEditCompany) => {
  console.log(company)
  return (
    <SideModal
      show={show}
      handleClose={close}
      title="Update Company Details"
      body={
        <>
          <Form>
            <FormInput
              classes="mb-3"
              onChange={(e: any) => onChangeValue(e)}
              value={company?.companyName}
              identifier="name"
              label="Company Name"
              readonly={true}
              disabled={true}
              type="text"
            />
            <FormInput
              classes="mb-3"
              onChange={(e: any) => onChangeValue(e)}
              value={company?.email}
              identifier="email"
              label="Company Email"
              type="email"
              readonly={true}
              disabled={true}
            />
            <FormInput
              classes="mb-3"
              onChange={(e: any) => onChangeValue(e)}
              value={company?.numberOfUsers}
              identifier="numberOfUsers"
              label="Total Employees"
              type="number"
            />

            <FormInput
              classes="mb-3"
              onChange={(e: any) => onChangeValue(e)}
              value={company?.numberOfAllowedQuestions}
              identifier="numberOfAllowedQuestions"
              label="Total Questions"
              type="number"
            />
            <div className="ds-field-row" data-class={editCompanyClass}>
              <div>
                <span className="ds-label" style={{ marginBottom: 0 }}>
                  Blocked
                </span>
                <span className="ds-help-text">
                  Restrict this company's access
                </span>
              </div>
              <Form.Switch checked={company?.blocked} onChange={onCheck} />
            </div>
          </Form>
        </>
      }
      footer={
        <div className="ds-drawer-actions" data-class={companyInputButtonsClass}>
          <button className="ds-btn ds-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button className="ds-btn ds-btn-primary" onClick={onSubmit}>
            Submit
          </button>
        </div>
      }
    />
  );
};

export default EditComapnyModal;
